<div
  class="gw-min-h-screen gw-w-full gw-overflow-x-hidden gw-bg-background-base gw-flex gw-items-start md:gw-items-center gw-justify-center"
>
  <div
    class="gw-mx-auto gw-w-full gw-max-w-[1600px] gw-px-4 gw-py-large sm:gw-px-6 lg:gw-px-8"
  >
    <div
      class="gw-grid gw-w-full gw-grid-cols-1 gw-gap-0 lg:gw-grid-cols-12 lg:gw-gap-8 xl:gw-gap-10"
    >
      <!-- Left: success content -->
      <div
        class="gw-col-span-1 gw-flex gw-w-full gw-justify-center lg:gw-col-span-6 lg:gw-items-center"
      >
        <div
          class="gw-w-full gw-max-w-[520px] gw-min-h-[480px] gw-flex gw-flex-col gw-items-center gw-justify-center gw-text-center gw-gap-large"
        >
          <!-- Success icon -->
          <div
            class="gw-flex gw-h-20 gw-w-20 gw-items-center gw-justify-center gw-rounded-full gw-bg-background-positive-1"
          >
            <gatewee-icon
              icon="@phi.check-circle"
              iconStyle="positive"
              size="2.5rem"
            ></gatewee-icon>
          </div>

          <!-- Text block -->
          <div class="gw-flex gw-flex-col gw-gap-small">
            <h1
              class="gw-text-2xl gw-font-semibold gw-text-text-primary gw-m-0"
            >
              {{ 'features.onboarding.success.title' | translate }}
            </h1>
            <p class="gw-text-base gw-text-text-secondary gw-m-0">
              {{ 'features.onboarding.success.subtitle' | translate }}
            </p>
          </div>

          <!-- Steps / what happens next -->
          <div
            class="gw-w-full gw-rounded-2xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-large gw-flex gw-flex-col gw-gap-medium gw-text-left"
          >
            <p class="gw-text-sm gw-font-semibold gw-text-text-primary gw-m-0">
              {{ 'features.onboarding.success.nextStepsTitle' | translate }}
            </p>

            <div class="gw-flex gw-flex-col gw-gap-small">
              <div class="gw-flex gw-items-start gw-gap-small">
                <gatewee-icon
                  icon="@phi.envelope-simple"
                  iconStyle="primary"
                  size="18px"
                  class="gw-shrink-0 gw-mt-0.5"
                ></gatewee-icon>
                <span class="gw-text-sm gw-text-text-secondary">
                  {{ 'features.onboarding.success.step1' | translate }}
                </span>
              </div>

              <div class="gw-flex gw-items-start gw-gap-small">
                <gatewee-icon
                  icon="@phi.magnifying-glass"
                  iconStyle="primary"
                  size="18px"
                  class="gw-shrink-0 gw-mt-0.5"
                ></gatewee-icon>
                <span class="gw-text-sm gw-text-text-secondary">
                  {{ 'features.onboarding.success.step2' | translate }}
                </span>
              </div>

              <div class="gw-flex gw-items-start gw-gap-small">
                <gatewee-icon
                  icon="@phi.rocket-launch"
                  iconStyle="primary"
                  size="18px"
                  class="gw-shrink-0 gw-mt-0.5"
                ></gatewee-icon>
                <span class="gw-text-sm gw-text-text-secondary">
                  {{ 'features.onboarding.success.step3' | translate }}
                </span>
              </div>
            </div>
          </div>

          <!-- CTA -->
          <a href="/login" class="gw-w-full">
            <gatewee-button
              variant="primary"
              class="gw-w-full"
              [title]="'features.onboarding.success.cta' | translate"
            ></gatewee-button>
          </a>
        </div>
      </div>

      <!-- Right: branded side panel -->
      <div class="gw-hidden lg:gw-col-span-6 lg:gw-block">
        <div
          [ngClass]="
            pageSettings?.onboarding?.sidePanel?.backgroundImage
              ? 'sidePanel'
              : 'sidePanel-no-img'
          "
          [ngStyle]="
            pageSettings?.onboarding?.sidePanel?.backgroundImage
              ? {
                  'background-image':
                    'url(' +
                    pageSettings!.onboarding!.sidePanel!.backgroundImage +
                    ')'
                }
              : {}
          "
          class="gw-relative gw-h-full gw-w-full gw-overflow-hidden gw-rounded-[32px] gw-p-6 gw-text-white lg:gw-min-h-[720px] xl:gw-p-8"
        >
          <div class="gw-absolute gw-left-0 gw-top-0 gw-p-6 xl:gw-p-8">
            <p
              class="gw-text-white gw-font-semibold"
              *ngIf="pageSettings?.onboarding?.sidePanel?.headerTitle"
            >
              {{ pageSettings!.onboarding!.sidePanel!.headerTitle }}
            </p>
            <img
              class="gw-max-w-[150px]"
              *ngIf="!pageSettings?.onboarding?.sidePanel?.headerTitle"
              [src]="style.logoWhite || style.logo"
              alt=""
            />
          </div>

          <div class="gw-absolute gw-bottom-0 gw-left-0 gw-p-6 xl:gw-p-8">
            <h1
              class="gw-text-white gw-font-bold"
              *ngIf="pageSettings?.onboarding?.sidePanel?.footerTitle"
            >
              {{ pageSettings!.onboarding!.sidePanel!.footerTitle }}
            </h1>
            <p
              class="gw-text-white"
              *ngIf="pageSettings?.onboarding?.sidePanel?.footerDescription"
            >
              {{ pageSettings!.onboarding!.sidePanel!.footerDescription }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
